import React, { useState, useContext } from "react";
import { useHistory } from "react-router-dom";

import {
  Avatar,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  Typography,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";

import ButtonWithSpinner from "../ButtonWithSpinner";
import MessagesList from "../MessagesList";
import { AuthContext } from "../../context/Auth/AuthContext";
import { ReplyMessageProvider } from "../../context/ReplyingMessage/ReplyingMessageContext";
import api from "../../services/api";
import toastError from "../../errors/toastError";

const useStyles = makeStyles(theme => ({
  header: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1.5),
  },
  contactInfo: {
    display: "flex",
    flexDirection: "column",
  },
  contactName: {
    fontWeight: 600,
    lineHeight: 1.2,
  },
  contactNumber: {
    fontSize: "0.8rem",
    color: theme.palette.text.secondary,
  },
  messagesContainer: {
    padding: 0,
    height: 480,
    display: "flex",
    flexDirection: "column",
    overflowY: "hidden",
  },
}));

const TicketPreviewModal = ({ open, ticket, onClose }) => {
  const classes = useStyles();
  const history = useHistory();
  const { user } = useContext(AuthContext);
  const [loading, setLoading] = useState(false);

  const handleAccept = async e => {
    setLoading(true);
    try {
      await api.put(`/tickets/${ticket.id}`, {
        status: "open",
        userId: user?.id,
        silent: e?.shiftKey,
      });
      onClose();
      history.push(`/tickets/${ticket.id}`);
    } catch (err) {
      setLoading(false);
      toastError(err);
    }
  };

  if (!ticket) return null;

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth scroll="paper">
      <DialogTitle disableTypography>
        <div className={classes.header}>
          <Avatar src={ticket.contact?.profilePicUrl} />
          <div className={classes.contactInfo}>
            <Typography className={classes.contactName}>
              {ticket.contact?.name}
            </Typography>
            <Typography className={classes.contactNumber}>
              {ticket.contact?.number}
              {" · "}
              <span style={{ opacity: 0.7 }}>#{ticket.id}</span>
              {ticket.queue && (
                <>
                  {" · "}
                  <span
                    style={{
                      backgroundColor: ticket.queue.color,
                      color: "#fff",
                      borderRadius: 4,
                      padding: "1px 6px",
                      fontSize: "0.72rem",
                    }}
                  >
                    {ticket.queue.name}
                  </span>
                </>
              )}
            </Typography>
          </div>
        </div>
      </DialogTitle>
      <Divider />
      <DialogContent className={classes.messagesContainer}>
        <ReplyMessageProvider>
          <MessagesList ticketId={ticket.id} isGroup={ticket.isGroup} />
        </ReplyMessageProvider>
      </DialogContent>
      <Divider />
      <DialogActions>
        <Button onClick={onClose} color="default">
          Fechar
        </Button>
        <ButtonWithSpinner
          color="primary"
          variant="contained"
          loading={loading}
          title="Shift+clique para atender sem enviar mensagem de saudação"
          onClick={handleAccept}
        >
          Aceitar chamado
        </ButtonWithSpinner>
      </DialogActions>
    </Dialog>
  );
};

export default TicketPreviewModal;
